module.exports = __webpack_public_path__ + "img/htkj_15.324f98ca.jpg";